import { getIcon } from "@litonarefin/utils/icons/index";
import Link from "next/link";

export const Pagination = ({
    href,
    query = "",
    prevPage,
    setPrevPage,
    nextPage,
    setNextPage,
    activePage,
    setActivePage,
    totalPage,
}) => {
    return (
        <div className="jlt-flex jlt-gap-2 jlt-items-center">
            {0 === prevPage ? null : (
                <Link
                    onClick={() => {
                        setActivePage(prevPage);
                        setNextPage(prevPage);
                        setPrevPage(prevPage - 1);
                    }}
                    href={`/${href}/page/${prevPage}/${query ? query : ""}`}
                    className="jlt-py-5 jlt-px-4 jlt-bg-[#fff] jlt-rounded-[2px] jlt-flex jlt-justify-center jlt-items-center">
                    <span className="jlt-rotate-180">
                        {getIcon("arrowRight")}
                    </span>
                </Link>
            )}

            {[...Array(totalPage).keys()]?.map((page, index) =>
                activePage === index + 1 ? (
                    <a
                        className={
                            "jlt-py-3 jlt-px-4 jlt-rounded-[2px] jlt-text-base jlt-font-bold jlt-flex jlt-text-white jlt-bg-[--primary] jlt-justify-center jlt-shadow-[0px_0px_10px_rgba(173,173,188,0.1)] jlt-items-center jlt-cursor-not-allowed"
                        }
                        key={index}>
                        {index + 1}
                    </a>
                ) : (
                    <Link
                        href={
                            index + 1 === 1
                                ? `/${href}/${query ? query : ""}`
                                : `/${href}/page/${index + 1}/${
                                      query ? query : ""
                                  }`
                        }
                        onClick={() => {
                            setNextPage(index + 1);
                            setPrevPage(index);
                            setActivePage(index + 1);
                        }}
                        key={index}
                        className={`jlt-py-3 jlt-px-4 jlt-rounded-[2px] jlt-text-base jlt-text-[--primary] jlt-bg-white jlt-font-bold jlt-flex jlt-justify-center jlt-shadow-[0px_0px_10px_rgba(173,173,188,0.1)] jlt-items-center`}>
                        {index + 1}
                    </Link>
                )
            )}

            {totalPage === nextPage ? null : (
                <Link
                    onClick={() => {
                        setActivePage(nextPage + 1);
                        setNextPage(nextPage + 1);
                        setPrevPage(nextPage);
                    }}
                    href={`/${href}/page/${nextPage + 1}/${query ? query : ""}`}
                    className="jlt-py-5 jlt-px-4 jlt-bg-[#fff] jlt-rounded-[2px] jlt-flex jlt-justify-center jlt-items-center">
                    {getIcon("arrowRight")}
                </Link>
            )}
        </div>
    );
};
